"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const broadcastGroupTranslations = {
    nameLabel: "Broadcast Name",
    namePlaceholder: "Broadcast Name",
    aboutLabel: "About",
    aboutPlaceholder: "N/A",
};
exports.default = broadcastGroupTranslations;
